<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_import_project_title' | translate }}</h4>

  <p>{{ 'dialog_import_project_instructions' | translate }}</p>

  <div class="file-upload-section">
    <div *ngIf="!selectedFile" class="file-input-container">
      <input type="file" id="fileInput" (change)="onFileSelected($event)" accept=".sevetp" class="file-input" #fileInput />
      <label for="fileInput" class="file-input-label">
        <mat-icon>cloud_upload</mat-icon>
        <span>{{ 'dialog_import_project_select_file' | translate }}</span>
        <small>{{ 'dialog_import_project_format' | translate }}</small>
      </label>
    </div>

    <div *ngIf="selectedFile" class="file-selected">
      <div class="file-info">
        <mat-icon class="file-icon">description</mat-icon>
        <div class="file-details">
          <span class="file-name">{{ fileName }}</span>
          <small class="file-size">{{ selectedFile.size / 1024 | localizedNumber: '1.2-2' }} KB</small>
        </div>
      </div>
      <button mat-icon-button (click)="onRemoveFile()" class="remove-file-btn" [matTooltip]="'dialog_import_project_change_file' | translate" [disabled]="isLoading">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="formatError" class="format-error">
      <mat-icon class="error-icon">error</mat-icon>
      <span class="error-message">{{ 'dialog_import_project_format_error' | translate }}</span>
    </div>

    <div *ngIf="apiError" class="format-error">
      <mat-icon class="error-icon">error</mat-icon>
      <span class="error-message">{{ apiError }}</span>
    </div>

    <div *ngIf="isLoading" class="loading-section">
      <mat-spinner diameter="24" class="loading-spinner"></mat-spinner>
      <span class="loading-message">{{ 'dialog_import_project_loading' | translate }}</span>
    </div>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()" [disabled]="isLoading">{{ 'common_btn_cancel' | translate }}</button>
    <button mat-button (click)="onImport()" color="accent" [disabled]="!canImport() || isLoading">
      <mat-spinner *ngIf="isLoading" diameter="16" class="button-spinner"></mat-spinner>
      <span>{{ isLoading ? ('common_btn_importing' | translate) : ('common_btn_import' | translate) }}</span>
    </button>
  </div>
</div>
